export default __webpack_public_path__ + "static/wealthx_logo-98783b5af6080e14aa428cd245e0dc16.png";